loadjs.ready('js_default', function () {
  $(document).ready(function () {
    new Accordeon();
    new HeaderShrink();
    new Nav();

    $('a[data-keyword]').click(function(e){
      Swal.fire({
        background: '#fefb93',
        showClass: {
          backdrop: 'swal2-noanimation', // disable backdrop animation
          popup: '',                     // disable popup animation
          icon: ''                       // disable icon animation
        },
        html: '<p class="t-call">'+$(this).attr('title')+'</p>' +
          '<p><a href="'+$(this).attr('href')+'" class="more"><span>mehr dazu unter</span><svg class="svg-item icon--arrow " viewBox="0 0 32 100">\n' +
          '                                <use xlink:href="#icon--arrow"/>\n' +
          '                            </svg></a></p>',
        showCloseButton: true,
        closeButtonHtml: '<div class="swal--close"></div>'

      });
      e.preventDefault();
    });


    $('body').addClass('loaded');
  });
});
